import { OrientationAxis } from '../../../enums/index.js';
import { clonePlanarOrientation } from './planarLegacyCompatibility.js';
export { PlanarRenderPathDecisionService, defaultPlanarRenderPathDecisionService, getPlanarAcquisitionOrientation, selectPlanarRenderPath, } from './PlanarRenderPathDecisionService.js';
export function normalizePlanarOrientation(orientation, acquisitionOrientation) {
    if (!orientation || orientation === OrientationAxis.ACQUISITION) {
        return OrientationAxis.ACQUISITION;
    }
    if (acquisitionOrientation && orientation === acquisitionOrientation) {
        return OrientationAxis.ACQUISITION;
    }
    return clonePlanarOrientation(orientation);
}
